module.exports = __webpack_public_path__ + "img/irazu.cb34d723.jpg";